import React, { useRef, useState } from 'react';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import './kebab-menu.scss';
import { SVGS } from '../../assets';

export type KebabOption =
  | {
      type: 'item';
      label: string;
      icon?: string;
      onClick: () => void;
      className?: string;
      hoverClassName?: string;
    }
  | {
      type: 'divider';
    };

interface KebabMenuProps {
  options: KebabOption[];
}

export const KebabMenu: React.FC<KebabMenuProps> = ({ options }) => {
  const popupRef = useRef<PopupActions>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popup
      ref={popupRef}
      trigger={
        <div
          className={`kebab-menu-trigger ${isOpen ? 'open' : ''}`}
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <img src={SVGS.KebabMenu} alt="" width={16} height={16} />
        </div>
      }
      position={['bottom right', 'top right']}
      closeOnDocumentClick
      nested
      arrow={false}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      contentStyle={{ padding: 0, border: 'none', background: 'transparent' }}
    >
      <div className="kebab-menu-dropdown">
        {options.map((option, index) =>
          option.type === 'divider' ? (
            <div key={index} className="kebab-menu-divider" />
          ) : (
            <div
              key={index}
              className={`kebab-menu-item ${option.className || ''}`}
              onClick={() => {
                option.onClick();
                popupRef.current?.close();
              }}
            >
              {option.icon && <img src={option.icon} alt="" width={20} />}
              <span className="menu-label font-regular">{option.label}</span>
            </div>
          )
        )}
      </div>
    </Popup>
  );
};
